export const FEATURE_FLAG_PREFIXES = {
  HIDE_PLATFORM: 'mycambridge.hide-platform',
  HIDE_ROLE: 'mycambridge.hide-role',
} as const;

export const getPlatformFlagName = (platformName: string): string => {
  const kebabCaseName = platformName.replace(/\s+/g, '-');
  return `${FEATURE_FLAG_PREFIXES.HIDE_PLATFORM}.${kebabCaseName}`;
};

export const getRoleFlagName = (roleName: string): string => {
  return `${FEATURE_FLAG_PREFIXES.HIDE_ROLE}.${roleName}`;
};
